module.exports = __webpack_public_path__ + "img/circle-info-gray-icon.24a4f0bc.svg";